import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MemberDataService } from '../../services/member-data.service';
import { Router } from '@angular/router';
import { GroupLeaderInfo } from './GroupLeaderInfo';
import { AuthService } from '@auth0/auth0-angular';
import { LoggingService } from 'src/app/utilities/logging.service';
import { TelementryService } from 'src/app/services/telemetry.service';
import { ActivityType } from 'src/app/models/ActivityType';

@Component({
  standalone: false,
  selector: 'app-groupleaderlist',
  templateUrl: './groupleaderlist.component.html',
  styleUrls: ['./groupleaderlist.component.scss']
})
export class GroupleaderlistComponent implements OnInit {
  dataSource: MatTableDataSource<GroupLeaderInfo>;
  displayedColumns: string[] = [
    'GroupName',
    'GroupID',
    'MGN',
    'RenewalMonth',
    'MemberCount'
  ];
  groupList: any[];
  loaded = false;

  months = [
    "-Select Month-",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  groupNames = [];
  groupIds = [];
  mgns = [];
  userName = "";
  filteredValues =
    {
      groupName: '',
      groupID: '',
      mgn: '',
      renewalMonth: ''
    };
  filterStr = '';


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator; // For pagination
  @ViewChild(MatSort, { static: false }) sort: MatSort; // For Sort
  constructor(
    private MemberDataService: MemberDataService,
    public dataService: UserService,
    private router: Router,
    public auth: AuthService,
    private cdr: ChangeDetectorRef,
    private userService : UserService,
    private telementryService: TelementryService,
  ) {}

  ngOnInit(): void {
    this.userName = this.userService.user.firstName + " " + this.userService.user.lastName;
    this.dataService.getGroupLeaderGroups(this.userService.user.email, this.userService.user.accountNumber).subscribe((list) => {
      this.loaded = true;

      this.cdr.detectChanges();

      let groups = [];
      this.groupList = list;
      
      list.forEach(group => {
        let newGroup = {
          GroupName: group.groupName,
          GroupID: group.groupId,
          MGN: group.mgn,
          RenewalMonth: group.renewalMonth,
          MemberCount: group.memberCount,
          GroupType: group.groupType,
          ShowDocuments: group.showDocuments,
          ShowMemberList: group.showMemberList,
          DocumentTypes: group.documentTypes
        }

        groups.push(newGroup);
        
      })
      if (groups.length == 1) {
        
        this.MemberDataService.selectedGroupID = groups[0].GroupId;
        this.MemberDataService.selectedGroupName = groups[0].GroupName;
        sessionStorage.setItem('accountType', groups[0].GroupType);
        sessionStorage.setItem('groupId', groups[0].GroupID);
        sessionStorage.setItem('showDocuments', groups[0].ShowDocuments);
        sessionStorage.setItem('showMemberList', groups[0].ShowMemberList);
        sessionStorage.setItem('documentTypes', groups[0].DocumentTypes);
        this.MemberDataService.notify({ isReload: true });
        this.dataService.setGroupLeaderAccountIsSelected(true);
        this.router.navigate(['/home']);
      }
      
      this.dataSource = new MatTableDataSource(groups);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = this.customFilterPredicate();

      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'RenewalMonth': {
            return this.months.indexOf(item.RenewalMonth);
          }
          case 'MemberCount':{
            return parseInt(item[property]);
          }
          default: return item[property];
        }
      };
    })
    
  }
  
  toCamelCase(name: string): string {
    return name.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }
  
  customFilterPredicate() {

    const myFilterPredicate = (data: GroupLeaderInfo, filter: string): boolean => {
      var globalMatch = !this.filterStr;

      if (this.filterStr) {
        // search all text fields
        var globalMatch =
          (typeof data.GroupName !== 'undefined' && data.GroupName !== null && data.GroupName.toLowerCase().includes(this.filterStr.toLowerCase()) ||
          (typeof data.GroupID !== 'undefined' && data.GroupID !== null && data.GroupID.toLowerCase().includes(this.filterStr.toLowerCase())) ||
          (typeof data.MGN !== 'undefined' && data.MGN !== null && data.MGN.toLowerCase().includes(this.filterStr.toLowerCase())) ||
          (typeof data.RenewalMonth !== 'undefined' && data.RenewalMonth !== null && data.RenewalMonth.toLowerCase().includes(this.filterStr.toLowerCase())) 
         
          );
      }
     
      if (!globalMatch) {
        return;
      }
      let allColumnsMatch = true;

      return allColumnsMatch;
    }
    return myFilterPredicate;
  }

  
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator; // For pagination
    this.dataSource.sort = this.sort;    
  }

  openMemberList(groupId: string, groupName: string): void {
    this.telementryService.trackSentryFeature(ActivityType.GroupView);
    let selectedGroup = this.groupList.filter(n => n.groupId == groupId.toString())[0];
    this.MemberDataService.selectedGroupID = groupId;
    this.MemberDataService.selectedGroupName = groupName;
    sessionStorage.setItem('accountType', selectedGroup.groupType);
    sessionStorage.setItem('groupId', groupId);
    sessionStorage.setItem('showDocuments', selectedGroup.showDocuments);
    sessionStorage.setItem('showMemberList', selectedGroup.showMemberList);
    sessionStorage.setItem('documentTypes', selectedGroup.documentTypes);
    this.MemberDataService.idType = "groupId";
    this.MemberDataService.formType='Group';
    this.MemberDataService.notify({ isReload: true });
    this.dataService.setGroupLeaderAccountIsSelected(true);
    this.router.navigate(['/home']);
  }

  applyFilter() {
    this.dataSource.filter = JSON.stringify(this.filteredValues);
    
  }

  updateSearchText(filterValue: string) {
    this.filterStr = filterValue.trim();
    this.applyFilter();
  }
}
